/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { AppContext } from '../../App';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import { handleCanonicalUrl } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { getConfiguration } from '../../data/utils/configuration';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';
import { appConfig } from '../../appConfig';
import MenuCategoryItem from '../menu/MenuCategoryItem';
import { PrematchContext } from '../Prematch';

function SportCollapse(props) {
    const conf = getConfiguration();
    const startCollapsed = conf.msc === true;
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    const seoContext = React.useContext(SeoContext);
    const [collapsed, setCollapsed] = useState(startCollapsed);
    const sportPath = [props.sport.urlPath, props.sport.urlPathSuffix].join('')
    const absoluteSportPath = useAbsolutePath(sportPath,null,props.sport.urlPathSeo);  
    const prematchPagePath = useAbsolutePath(appConfig.ROUTES.prematch['prematch'],null,null,true);

    useEffect(() => {
        if(!window.appConfig.SHOP_MODE){
            if(!props.showDesc){
                //if(window.history){
                    seoContext.refreshPathname(sportPath,appContext.location.current);
                    handleCanonicalUrl(absoluteSportPath);
                    //window.history.replaceState(window.history.state, null, absoluteSportPath);
                //}
                return () =>{
                    //appContext.location.current === 'prematch' && window.history.replaceState(window.history.state, null, absoluteSportPath.substring(0,absoluteSportPath.indexOf(props.sport.urlPath)));
                }
            }else{
                if((seoContext.pathname || null) != null && seoContext.pathname != appContext.location.current){
                    if(appConfig?.ROUTES?.routeFromPath(window.location.pathname) === 'prematch'){
                        seoContext.refreshPathname(prematchPagePath,appContext.location.current);
                        handleCanonicalUrl(prematchPagePath);
                    }
                    //window.history.replaceState(window.history.state, null, prematchPagePath);
                }
               
            }

        }
    }, [props.showDesc]);

    function handleClickHref(e){
        e.preventDefault();
    }

    function handleClick() {
        setCollapsed(!collapsed);
    }

    useEffect(() => {
        setCollapsed(startCollapsed);
    }, [prematchContext.sport]);
    
    return (
        <>
            {(props.showDesc) &&
                <a className="sport-anchor" href={encodeURI(absoluteSportPath)} onClick={handleClickHref.bind(this)} >
                    <div className="list-element sport-collapse" onClick={handleClick}>
                        <div className={`prematch-sport-img big ${iconSportCssClass(props.sport.id, props.sport.iconClass)}`}></div>
                        <span className="list-element-text list-heading">{props.sport.descrizione}</span>
                        <div className="d-flex push-right mr-2">
                            {props.sport.isLive &&
                                <div className="badge-live mr-2"></div>
                            }
                            <span className="list-element-info">{props.sport.categories.length}</span>
                        </div>
                        {props.showDesc && 
                            <span className={"arrow " + (collapsed ? 'arrow-expand' : 'arrow-collapse')}></span>
                        }
                    </div>
                </a>
            }
            {(!collapsed || !props.showDesc) &&
                <div className="menu-container">
                    {prematchContext.applyTemporalFilter(props.sport.categories).map(function(c) {
                        function handleClick() {
                            prematchContext.openCategory(c);
                        }
                        return (
                                <MenuCategoryItem key={c.id}
                                                    id={c.id}
                                                    desc={c.descrizione}
                                                    info={c.tournamentsCount}
                                                    sportRef={c.sportRef}
                                                    categoryRef={c.id}
                                                    iconClass={c.iconClass}
                                                    isLive={c.isLive}
                                                    action={handleClick}
                                                    urlPath={c.urlPath}
                                                    urlPathSuffix={c.urlPathSuffix}
                                                    urlPathSeo={c.urlPathSeo}
                                                    urlPathSeoSettings = {c.urlPathSeoSettings} />
                        );
                    })}
                </div>
            }
        </>
    )
}

export default SportCollapse;